class TechnicalMenu extends HTMLElement {
    constructor() {
        super();
        this.mobileToggle = this.querySelector('.technical-menu__mobile-toggle');
        this.menuList = this.querySelector('.technical-menu__list');

        if (this.mobileToggle) {
        this.mobileToggle.addEventListener('click', this.onMobileToggle.bind(this));
        }
    }

    onMobileToggle() {
        const isExpanded = this.mobileToggle.getAttribute('aria-expanded') === 'true';
        this.mobileToggle.setAttribute('aria-expanded', !isExpanded);
    }
}

customElements.define('technical-menu', TechnicalMenu);